var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect8, _rect9, _rect10, _path9, _rect11, _rect12, _rect13, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 353,
    viewBox: "0 0 631 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 14.6139,
    transform: "matrix(0.00360654 -0.999994 0.999956 0.0094223 275.184 129.777)",
    fill: "url(#paint0_linear_405_1413)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 65.9842,
    transform: "matrix(-0.00360651 0.999994 0.999956 0.00942227 239.604 325.722)",
    fill: "url(#paint1_linear_405_1413)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 50.1352,
    transform: "matrix(1 9.24452e-10 -0.00561531 0.999984 314.716 107.582)",
    fill: "url(#paint2_linear_405_1413)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 56.5485,
    transform: "matrix(0.00447538 -0.999995 -0.999822 -0.0166023 361.879 352.695)",
    fill: "url(#paint3_linear_405_1413)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 56.5434,
    transform: "matrix(0.00440648 -0.999995 1 -0.00341052 267.725 352.083)",
    fill: "url(#paint4_linear_405_1413)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 14.6139,
    transform: "matrix(-0.00360657 0.999994 -0.999956 -0.00942233 356.29 128.228)",
    fill: "url(#paint5_linear_405_1413)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 65.9842,
    transform: "matrix(0.00360648 -0.999994 -0.999956 -0.00942224 390.124 327.699)",
    fill: "url(#paint6_linear_405_1413)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.545 218.143L338.027 132.198C337.955 131.005 338.713 128.796 342.325 129.513L512.224 129.513C513.971 129.14 518.124 129.692 520.76 134.884L564.204 195.314C565.542 197.179 569.026 200.909 572.263 200.909L628.657 200.909",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.803 218.367L293.286 132.341C293.372 131.146 292.638 128.935 289.014 129.652L118.981 129.652C117.236 129.279 113.074 129.832 110.377 135.03L66.2192 195.531C64.8593 197.398 61.3295 201.133 58.0908 201.133L1.65102 201.133",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M292.254 317.069L292.214 324.231C292.287 325.276 291.816 327.365 289.341 327.365L220.097 327.365C219.462 327.365 217.724 326.111 215.849 321.098C215.437 319.997 213.5 315.175 210.553 307.893M1.53447 221.948L21.4035 221.948M137.466 189.943L137.446 193.524L137.487 186.138M137.466 189.943L148.709 189.943M137.466 189.943L126.223 189.943M148.709 189.943L159.953 189.943C162.047 189.943 163.508 192.33 163.978 193.524C174.072 218.249 190.515 258.563 202.197 287.302M148.709 189.943L148.689 193.524L148.731 186.138M126.223 189.943L114.98 189.943C113.553 189.793 110.028 190.301 107.345 193.524L96.9243 205.945M126.223 189.943L126.203 193.524L126.244 186.138M96.9243 205.945L86.5036 218.367C85.3071 219.561 82.5335 221.948 81.0106 221.948L61.1415 221.948M96.9243 205.945L107.275 205.945L86.5733 205.945M41.2725 221.948L41.2461 226.648M41.2725 221.948L61.1415 221.948M41.2725 221.948L21.4035 221.948M61.1415 221.948L61.1152 226.648M21.4035 221.948L21.3771 226.648M210.553 307.893L222.11 307.893M210.553 307.893C209.325 304.858 207.921 301.396 206.379 297.597M206.379 297.597L222.167 297.597M206.379 297.597C205.076 294.387 203.675 290.937 202.197 287.302M202.197 287.302L222.225 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.997 317.069L336.957 324.231C336.872 325.276 337.32 327.365 339.795 327.365L409.039 327.365C409.673 327.365 411.425 326.111 413.357 321.098C413.782 319.997 415.773 315.175 418.802 307.893M628.785 221.948L608.916 221.948M493.213 189.943L493.193 193.524L493.234 186.138M493.213 189.943L481.97 189.943M493.213 189.943L504.456 189.943M481.97 189.943L470.726 189.943C468.632 189.943 467.144 192.33 466.661 193.524C456.289 218.249 439.393 258.563 427.388 287.302M481.97 189.943L481.95 193.524L481.991 186.138M504.456 189.943L515.699 189.943C517.128 189.793 520.647 190.301 523.294 193.524L533.575 205.945M504.456 189.943L504.436 193.524L504.478 186.138M533.575 205.945L543.856 218.367C545.039 219.561 547.786 221.948 549.309 221.948L569.178 221.948M533.575 205.945L523.224 205.945L543.926 205.945M589.047 221.948L589.021 226.648M589.047 221.948L569.178 221.948M589.047 221.948L608.916 221.948M569.178 221.948L569.152 226.648M608.916 221.948L608.89 226.648M418.802 307.893L407.245 307.893M418.802 307.893C420.064 304.858 421.506 301.396 423.091 297.597M423.091 297.597L407.302 297.597M423.091 297.597C424.429 294.387 425.87 290.937 427.388 287.302M427.388 287.302L407.36 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.744 202.028L316.739 24.7674C316.743 24.0213 317.227 22.5292 319.131 22.5292L519.249 22.5292C521.47 22.6039 525.915 21.9921 525.932 18.9482C525.949 15.9043 525.994 7.8321 526.015 4.17647C525.941 3.28121 526.363 1.49069 528.647 1.49069L619.614 1.1582",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.242 202.028L316.237 24.7674C316.241 24.0213 315.774 22.5292 313.874 22.5292L114.06 22.5292C111.842 22.6038 115.415 21.8119 115.432 18.7681C115.449 15.7242 115.495 7.65195 115.515 3.99632C115.599 3.10106 107.193 1.49069 104.912 1.49069L11.703 1.31055",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M315 337.884L314.955 345.941C314.786 347.881 315.493 351.76 319.681 351.76L492.673 351.76C493.941 351.909 497.388 351.044 501.031 346.389L558.069 274.32C559.107 273.052 561.612 270.516 563.325 270.516L628.286 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.01 337.884L313.964 345.941C314.112 347.881 313.361 351.76 309.173 351.76L136.181 351.76C134.911 351.909 131.474 351.044 127.883 346.389L71.6552 274.32C70.6312 273.052 68.1548 270.516 66.4416 270.516L1.48056 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 532.812 22.7529)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 3.12891 22.7532)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 614.184 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 599.419 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 584.655 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M569.886 193.822C569.888 193.41 570.224 193.076 570.636 193.076L578.844 193.076C579.949 193.076 580.839 193.971 580.833 195.076L580.83 195.727C580.824 196.735 580.002 197.552 578.994 197.552L573.595 197.552C571.535 197.552 569.874 195.882 569.886 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 16.9375 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 31.7021 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 46.4668 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2273 193.822C61.2296 193.41 60.8974 193.076 60.4854 193.076L52.2772 193.076C51.1726 193.076 50.2721 193.971 50.2659 195.076L50.2623 195.727C50.2566 196.735 51.0694 197.552 52.0778 197.552L57.476 197.552C59.5362 197.552 61.2157 195.882 61.2273 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_405_1413",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 14.6139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_405_1413",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 65.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_405_1413",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_405_1413",
    x1: 0.909125,
    y1: 0,
    x2: 0.909125,
    y2: 56.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_405_1413",
    x1: 0.909125,
    y1: 0,
    x2: 0.909125,
    y2: 56.5434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_405_1413",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 14.6139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_405_1413",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 65.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame5);
export default __webpack_public_path__ + "static/media/card1-frame5.a6a13abdc72e0489c6e21e43e083f230.svg";
export { ForwardRef as ReactComponent };